//import UseOrderDetPopup from "@/pages/comp/book_order/book_order_use/popup/use_order_det";
import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import getXcolumnJson from "./xcolumn/list";
import DetListArea from "./area/list";

function UseOrderDetPopup(props: any) {
  let myProps = {
    order_det_seq_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();

  const [order_det_info_arr, set_order_det_info_arr] = useState<any>([]);
  const [stu_info_arr, set_stu_info_arr] = useState<any>([]);

  useEffect(() => {
    get_order_det_info_by_ajax({
      order_det_seq_arr: myProps.order_det_seq_arr
    });
  }, []);

  const get_order_det_info_by_ajax = (inData: any) => {
    let opt_obj = {
      order_det_seq_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.order_det_seq_arr) || opt_obj.order_det_seq_arr.length == 0) {
      alert("선택된 주문내역이 없습니다.");
      myProps.closePopup();
      return false;
    }
    let form_json_data: any = {
      s_mcomp_seq: user.comp_seq,
      s_pri_arr: opt_obj.order_det_seq_arr,
      s_addon_product: "1",
      s_addon_product_s_addon_par_obj: "1",
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_order_det_info_arr(response.data["data"]["info_arr"]);
          let stu_seq_arr: any = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let order_det = response.data["data"]["info_arr"][i];
            if (!strFunc.is_empty(order_det["a_buy_user_seq"])
              && strFunc.str_in_array(order_det["a_buy_user_seq"], stu_seq_arr) == -1) {
              stu_seq_arr.push(order_det["a_buy_user_seq"]);
            }
            get_stu_info_by_ajax({
              stu_seq_arr: stu_seq_arr
            });
          }
        } else {
          alert("주문내역 정보를 불러오는데 실패하였습니다." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const get_stu_info_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.stu_seq_arr) || opt_obj.stu_seq_arr.length == 0) {
      return false;
    }
    let form_json_data: any = {
      s_seq: opt_obj.stu_seq_arr,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_info_arr(response.data["data"]["info_arr"]);
        } else {
          alert("주문내역 정보를 불러오는데 실패하였습니다." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const go_use_of_order_det_by_ajax = (inData: any) => {
    let opt_obj = {
      order_det_arr: order_det_info_arr,
      ...inData
    };

    if (opt_obj.order_det_arr.length == 0) {
      alert("선택된 주문내역이 없습니다.");
      return false;
    }

    if (confirm("선택된 교재를 승인 하시겠습니까?") == false) {
      return false;
    }

    let order_det_seq_arr: any = [];
    for (let i = 0; i < opt_obj.order_det_arr.length; i++) {
      let order_det = opt_obj.order_det_arr[i];

      if (!strFunc.is_empty(order_det["row_pri_val"])) {
        order_det_seq_arr.push(order_det["row_pri_val"]);
      }
    }

    let form_json_data: any = {
      "data_arr": order_det_info_arr,
      "is_update": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          use_of_order_by_ajax({
            order_det_arr: response.data.data,
          });
        } else {
          alert("승인처리에 실패하였습니다." + response.data["msg"]);
          myProps.refreshData({});
          myProps.closePopup();
        }
      });
  };

  const use_of_order_by_ajax = (inData: any) => {
    let opt_obj = {
      order_det_arr: order_det_info_arr,
      ...inData
    };

    let order_det_seq_arr: any = [];
    for (let i = 0; i < opt_obj.order_det_arr.length; i++) {
      let order_det = opt_obj.order_det_arr[i];

      if (!strFunc.is_empty(order_det["row_pri_val"])) {
        order_det_seq_arr.push(order_det["row_pri_val"]);
      }
    }

    let form_json_data: any = {
      "mcomp_seq": user.comp_seq,
      "order_det_seq_arr": order_det_seq_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/use_of_order_det',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("승인처리가 완료되었습니다.");
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert("승인처리에 실패하였습니다." + response.data["msg"]);
          myProps.refreshData({});
          myProps.closePopup();
        }
      });
  };

  return (
    <div>
      <div>
        <h3>교재사용승인</h3>
      </div>
      <DetListArea
        order_det_info_arr={order_det_info_arr}
        set_order_det_info_arr={set_order_det_info_arr}
        stu_info_arr={stu_info_arr}
        xColumnArr={xColumnArr}
      ></DetListArea>
      <div className='my_flex_center mt-1'>
        <button className='btn btn-dark'
          onClick={() => {
            go_use_of_order_det_by_ajax({});
          }}
        >승인</button>
        <button className='btn btn-dark'
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
      </div>
    </div>
  );
};
export default UseOrderDetPopup;